/* assets/ymm-link-rewriter.js — v4.7
 * Persists the YMM selection across collection navigation by rewriting
 * every <a href="/collections/..."> to include:
 *   - filter.p.m.custom.fitment_model=<code>  (server-side, requires S&D filter)
 *   - ymm=YEAR|MODEL|TRIM|ENGINE              (client-side, ymm-global.js reads this)
 * Re-runs on YMM change / reset and on dynamic DOM mutations.
 */
(function () {
  var KEY = 'ymm.selection.v11';

  function readSel() {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; }
    catch (e) { return {}; }
  }
  function active(s) {
    return !!(s && (s.year || s.model || s.trim || s.engine));
  }
  function pipe(s) {
    return [s.year || '', s.model || '', s.trim || '', s.engine || ''].join('|');
  }

  function rewriteAll() {
    var s = readSel();
    if (!active(s)) return;
    var p = pipe(s);
    var links = document.querySelectorAll('a[href*="/collections/"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.dataset.ymmRewritten === '1') continue;
      try {
        var u = new URL(a.href, location.origin);
        if (!/^\/(?:[a-z]{2}\/)?collections\//.test(u.pathname)) continue;
        // Skip /collections/all/products/... (PDP URLs)
        if (u.pathname.indexOf('/products/') > -1) continue;

        if (!u.searchParams.has('ymm')) u.searchParams.set('ymm', p);
        if (s.model && !u.searchParams.has('filter.p.m.custom.fitment_model')) {
          u.searchParams.set('filter.p.m.custom.fitment_model', s.model);
        }
        a.href = u.pathname + u.search + u.hash;
        a.dataset.ymmRewritten = '1';
      } catch (e) { /* skip bad URLs */ }
    }
  }

  function clearAll() {
    var links = document.querySelectorAll('a[data-ymm-rewritten="1"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      try {
        var u = new URL(a.href, location.origin);
        u.searchParams.delete('ymm');
        u.searchParams.delete('filter.p.m.custom.fitment_model');
        a.href = u.pathname + u.search + u.hash;
      } catch (e) {}
      a.removeAttribute('data-ymm-rewritten');
    }
  }

  // Initial pass
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewriteAll);
  } else {
    rewriteAll();
  }
  window.addEventListener('load', rewriteAll);

  // React to YMM state changes
  window.addEventListener('ymm:changed', function () {
    // Re-mark all links so the new selection is applied
    var marked = document.querySelectorAll('a[data-ymm-rewritten="1"]');
    for (var i = 0; i < marked.length; i++) marked[i].removeAttribute('data-ymm-rewritten');
    rewriteAll();
  });
  window.addEventListener('ymm:reset', clearAll);
  document.addEventListener('ymm:applied', rewriteAll);

  // Watch for dynamically added links (lazy menus, predictive search, etc.)
  var debounce;
  var mo = new MutationObserver(function () {
    clearTimeout(debounce);
    debounce = setTimeout(rewriteAll, 120);
  });
  try { mo.observe(document.body, { childList: true, subtree: true }); }
  catch (e) {}
})();
